import { BaseFilter } from "components/UI/BaseFilter/BaseFilter.tsx";

interface CascadeFilterProps {
    cascadeId: string;
}

export const CascadeFilter = ({ cascadeId }: CascadeFilterProps) => {
    return (
        <BaseFilter cascade={{ id: cascadeId }} />
    );
};